import {all, call, put, select, takeEvery} from 'redux-saga/effects';
import {ORPYXSI_ADMIN_URL} from "../../../../../appConstants";
import {AdminOrpyxUsersHttpClient, IOrpyxUserDto} from "admins-dashboard/http-clients/index";
import {ENQUEUE_SNACKBAR, fullNamePipe, StoreActionAfterComplete} from "orpyx-web-common";
import {DELETE_ORPYX_USER_FAILED, DELETE_ORPYX_USER_SUCCESSFULLY, OrpyxUserDeleteActions} from "./orpyx-user-delete-actions";
import OrpyxUserDeleteSelectors from "./orpyx-user-delete-selectors";

const API_VERSIONS = '1';

function* onOrpyxUserDelete() {
    try {
        const user: IOrpyxUserDto = yield select(OrpyxUserDeleteSelectors.user);
        const actionAfterComplete: StoreActionAfterComplete = yield select(OrpyxUserDeleteSelectors.actionAfterComplete);

        const userId = user.orpyxUserId!;

        const api = new AdminOrpyxUsersHttpClient(ORPYXSI_ADMIN_URL);
        const data: IOrpyxUserDto = yield call(
            [api, api.deleteOrpyxUser],
            userId,
            API_VERSIONS
        );

        yield put(DELETE_ORPYX_USER_SUCCESSFULLY(actionAfterComplete));
        yield put(ENQUEUE_SNACKBAR({
            message: `User ${fullNamePipe(data)} successfully deleted`,
            options: {variant: "success"}
        }));

    } catch (e) {
        yield put(DELETE_ORPYX_USER_FAILED(e));
    }
}

export default function* OrpyxUserDeleteSagas() {
    yield all([
        yield takeEvery(OrpyxUserDeleteActions.DELETE_USER, onOrpyxUserDelete),

    ]);
}

